import { NgModule } from '@angular/core';
import { LibCarFinanceIconComponent } from './lib-car-finance-icon.component';

@NgModule({
  declarations: [LibCarFinanceIconComponent],
  imports: [],
  exports: [LibCarFinanceIconComponent],
})
export class LibCarFinanceIconModule {}
